import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
import appConfig from '../config/app.json';

import HomeView from '../views/HomeView.vue';
import LoginView from '../views/LoginView.vue';
import DesktopQrLoginView from '../views/DesktopQrLoginView.vue';
import BookView from '../views/BookView.vue';
import RequestsView from '../views/RequestsView.vue';
import RequestDetailsView from '../views/RequestDetailsView.vue';
import ClubsView from '../views/ClubsView.vue';
import MenuView from '../views/MenuView.vue';
import ProfileView from '../views/ProfileView.vue';
import SettingsView from '../views/SettingsView.vue';
import AccountHistoryView from '../views/AccountHistoryView.vue';
import ClubDetailsView from '../views/ClubDetailsView.vue';
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue';
import PersonalDataConsentView from '../views/PersonalDataConsentView.vue';

const routes = [
  { path: '/', component: HomeView, meta: { requiresAuth: true, title: 'Главная' } },
  { path: '/login', component: LoginView, meta: { title: 'Вход' } },
  { path: '/login/desktop', component: DesktopQrLoginView, meta: { title: 'Вход по QR' } },
  { path: '/book', component: BookView, meta: { requiresAuth: true, title: 'Бронь' } },
  { path: '/requests', component: RequestsView, meta: { requiresAuth: true, title: 'Мои брони' } },
  { path: '/requests/:orderNumber', component: RequestDetailsView, meta: { requiresAuth: true, title: 'Детали брони' } },
  { path: '/profile', component: ProfileView, meta: { requiresAuth: true, title: 'Профиль' } },
  { path: '/settings', component: SettingsView, meta: { requiresAuth: true, title: 'Настройки' } },
  { path: '/account-history', component: AccountHistoryView, meta: { requiresAuth: true, title: 'История счёта' } },
  { path: '/clubs', component: ClubsView, meta: { requiresAuth: true, title: 'Клубы' } },
  { path: '/clubs/:clubId', component: ClubDetailsView, meta: { requiresAuth: true, title: 'Клуб' } },
  { path: '/menu', component: MenuView, meta: { requiresAuth: true, title: 'Меню' } },
  { path: '/privacy-policy', component: PrivacyPolicyView, meta: { title: 'Политика конфиденциальности' } },
  { path: '/personal-data-consent', component: PersonalDataConsentView, meta: { title: 'Согласие на обработку данных' } },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0, behavior: 'auto' };
  },
});

router.beforeEach(async (to, from, next) => {
  await store.dispatch('auth/bootstrap');
  const isAuthenticated = store.getters['auth/isAuthenticated'];

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login');
    return;
  }

  if (to.path === '/login' && isAuthenticated) {
    next('/');
    return;
  }

  next();
});

router.afterEach((to) => {
  const pageTitle = to.meta?.title;
  document.title = pageTitle
    ? `${pageTitle} — ${appConfig.brand.name}`
    : appConfig.brand.name;
});

export default router;